import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { MotifTable, MotifTextLink, MotifIcon } from '@ey-xd/motif-react';
import { contentIcAddCircle24px } from '@ey-xd/motif-react/assets/icons';
import {
  FooterTable,
  TableData1B,
  TableData1C,
  TableData3DotStyle,
} from '../../../../atoms/gcsp/gcspTable.styles';
import JudgeModal from '../../../../organisms/modals/judgeModal';
import {
  Active_Tab_Gcsp,
  All_Month_Data_State,
  Gcsp_Opp_View_State,
} from '../../../../../recoil/recoil';
import { useRecoilState } from 'recoil';
import { formateTOV } from '../../../../../util/commonUtil';
import TableHeader from '../../../../molecules/dcsp/components/tableHeader';
import '../../../gcsp/styles/styles.css';

const GcspTableData = ({ refValue }) => {
  const bottomGrid = useRef(null);

  const handleUploadImage = value => {
    alert(value);
  };
  const [gcspOppViewData, setGcspOppViewData] = useRecoilState(Gcsp_Opp_View_State);

  const [allMonthData, setAllMonthData] = useRecoilState(All_Month_Data_State);
  const [tabActive, setTabActive] = useRecoilState(Active_Tab_Gcsp);

  let rowData = [];
  if (
    gcspOppViewData.length !== 0 &&
    allMonthData[tabActive].Total_Forecasted !== null &&
    allMonthData[tabActive].Your_Judge !== null &&
    allMonthData[tabActive].Total_Commit !== null
  ) {
    const rowDataTotalForecasted = allMonthData[tabActive].Total_Forecasted.map(data => ({
      ...data,
      background: '#ffffff',
    }));

    const rowDataTotalYourJudge = allMonthData[tabActive].Your_Judge.map(data => ({
      ...data,
      background: '#ffffff',
    }));
    const rowDataTotalCommit = allMonthData[tabActive].Total_Commit.map(data => ({
      ...data,
      background: '#ffffff',
    }));
    rowData = rowDataTotalForecasted.concat(rowDataTotalYourJudge, rowDataTotalCommit);
  }

  const CommentColumnRenderer = ({ value }) => (
    <div style={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
      <div>
        <MotifTextLink variant="alt" href="#">
          {value}
        </MotifTextLink>
        <span style={{ margin: '3px' }}> </span>
        <MotifIcon src={contentIcAddCircle24px} onClick={handleUploadImage} />
      </div>
    </div>
  );

  const ColumnHeaderRenderer = ({ value, data }) => {
    const keyToText = {
      'Total Forecasted': 'PL Total Committed',
      'Your Judge': 'Your Judge',
      'Total Commit': 'Your Total Commit',
    };
    const category = data.category;
    const displayText = keyToText[category] || '';

    return (
      <TableData1B>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span>{displayText}</span>
        </div>
      </TableData1B>
    );
  };

  const OnlyCommittedRenderer = ({ value, data }) => {
    let dynamicBackgroundColor = '#168736';
    const keyToText = {
      'Total Forecasted': 'Commit Only (Totals do not include No Commit or Missed)',
    };
    const category = data.category;
    const displayText = keyToText[category] || '';

    return (
      <TableData1C>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {displayText && <TableData3DotStyle backgroundColor={dynamicBackgroundColor} />}
          {displayText && <span>{displayText}</span>}
        </div>
      </TableData1C>
    );
  };

  const TextCellRendererC = props => {
    const { value, data, KeyName } = props;
    if (data.category === 'Your Judge') {
      return <JudgeModal KeyName={KeyName} />;
    } else {
      return formateTOV(value);
    }
  };

  TextCellRendererC.propTypes = {
    value: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  };

  const TOVCellRenderer = props => {
    const { value, assurance, consulting, sat, tax, itts, EMIAACR, KeyName, data } = props;
    let TotalTov =
      Number(assurance) +
      Number(consulting) +
      Number(sat) +
      Number(tax) +
      Number(itts) +
      Number(EMIAACR);

    TotalTov = formateTOV(TotalTov);

    if (data.category === 'Your Judge' && KeyName === 'TOV') {
      return <TableData1C style={{ fontWeight: 'bold', marginRight: 30 }}>{TotalTov} </TableData1C>;
    } else if (data.category === 'Total Forecasted' && KeyName === 'TOV') {
      return <TableData1C style={{ fontWeight: 'bold', marginRight: 30 }}>{TotalTov} </TableData1C>;
    } else if (data.category === 'Total Commit' && KeyName === 'TOV') {
      return <TableData1C style={{ fontWeight: 'bold', marginRight: 30 }}>{TotalTov} </TableData1C>;
    } else {
      return formateTOV(value);
    }
  };

  TOVCellRenderer.propTypes = {
    value: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  };

  const columnDefs = [
    {
      headerName: 'Total',
      width: 200,
      cellRenderer: ColumnHeaderRenderer,
    },
    {
      headerName: '',
      width: 995,
      cellRenderer: OnlyCommittedRenderer,
    },
    {
      headerName: 'Assurance',
      field: 'Assurance',
      width: 165,
      id: 1,
      cellRenderer: 'textCellRendererC',
      cellRendererParams: params => {
        const KeyName = 'Assurance';
        return {
          KeyName,
        };
      },
      cellStyle: { justifyContent: 'flex-end' },
      headerComponentParams: {
        subText: 'excl. EMEIA ACR',
      },
    },
    {
      headerName: 'Consulting',
      field: 'consulting',
      width: 165,
      cellRenderer: 'textCellRendererC',
      cellRendererParams: params => {
        const KeyName = 'consulting';
        return {
          KeyName,
        };
      },
      cellStyle: { justifyContent: 'flex-end' },
    },
    {
      headerName: 'SAT',
      field: 'sat',
      width: 165,
      cellRenderer: 'textCellRendererC',
      cellRendererParams: params => {
        const KeyName = 'sat';
        return {
          KeyName,
        };
      },
      cellStyle: { justifyContent: 'flex-end' },
      headerComponentParams: { subText: 'excl. ITTS' },
    },
    {
      headerName: 'Tax',
      field: 'tax',
      width: 165,
      cellRenderer: 'textCellRendererC',
      cellRendererParams: params => {
        const KeyName = 'tax';
        return {
          KeyName,
        };
      },
      cellStyle: { justifyContent: 'flex-end' },
      headerComponentParams: { subText: 'excl. ITTS' },
    },
    // {
    //   headerName: 'PAS',
    //   field: 'pas',
    //   width: 125,
    //   cellRenderer: 'textCellRendererC',
    //   cellStyle: { justifyContent: 'flex-end' }
    // },
    {
      headerName: 'IITS',
      field: 'itts',
      width: 165,
      cellRenderer: 'textCellRendererC',
      cellStyle: { justifyContent: 'flex-end' },
      cellRendererParams: params => {
        const KeyName = 'itts';
        return {
          KeyName,
        };
      },
    },
    {
      headerName: 'EMIA ACR',
      field: 'EMIAACR',
      width: 165,
      cellRenderer: 'textCellRendererC',
      cellStyle: { justifyContent: 'flex-end' },
      cellRendererParams: params => {
        const KeyName = 'EMIAACR';
        return {
          KeyName,
        };
      },
    },
    {
      headerName: 'TOV',
      field: 'TOV',
      width: 180,
      cellRenderer: 'tovCellRenderer',
      cellStyle: { justifyContent: 'flex-end' },
      cellRendererParams: params => {
        const KeyName = 'TOV';
        const assurance = params.data.Assurance;
        const consulting = params.data.consulting;
        const sat = params.data.sat;
        const tax = params.data.tax;
        const itts = params.data.itts;
        const EMIAACR = params.data.EMIAACR;
        return {
          KeyName,
          assurance,
          consulting,
          sat,
          tax,
          itts,
          EMIAACR,
        };
      },
    },
  ];

  const getRowStyle = params => {
    return { background: params.data.background };
  };
  return (
    <FooterTable>
      <MotifTable
        ref={bottomGrid}
        alignedGrids={[refValue?.current]}
        columnDefs={columnDefs}
        rowData={rowData}
        components={{
          agColumnHeader: TableHeader,
          commentColumnRenderer: CommentColumnRenderer,
          textCellRendererC: TextCellRendererC,
          tovCellRenderer: TOVCellRenderer,
        }}
        headerHeight={0}
        headerCellWidth={200}
        getRowStyle={getRowStyle}
        alwaysShowHorizontalScroll={true}
        overlayNoRowsTemplate="Loading..."
      />
    </FooterTable>
  );
};
export default GcspTableData;
